export const telecomDoorStatusConvert = (telecomDoorStatus: any) => {
  return (telecomDoorStatus >> 1) & 1;
};

export const pcDoorStatusConvert = (pcDoorStatus: any) => {
  return (pcDoorStatus === 3); // if pcDoorStatus==3 => Door closed
};
